import { useEffect } from 'react';
import { useLazyGetAllDocumentsByMilestonenameSiteLevelQuery } from 'src/services/etmfDocLevel';
import { useLazyGetAllDocumentsByMilestonenameSiteLevelISFQuery } from 'src/services/isfDocLevel';
import { useAppDispatch } from 'src/store/hooks';
import { updateUserAccess } from 'src/util/util';
export const useAssociateDocuments = () => {
  const dispatch = useAppDispatch();
  const [getAllDocsByMilestoneNameSitelevel, { error: associateDocsError }] =
    useLazyGetAllDocumentsByMilestonenameSiteLevelQuery();
  const [getAllDocsByMilestoneNameSitelevelISF, { error: associateDocsErrorISF }] =
    useLazyGetAllDocumentsByMilestonenameSiteLevelISFQuery();
  useEffect(() => {
    if (associateDocsError || associateDocsErrorISF) {
      updateUserAccess(associateDocsError || associateDocsErrorISF, dispatch);
    }
  }, [associateDocsError, associateDocsErrorISF]);
  return {
    getAllDocsByMilestoneNameSitelevel,
    getAllDocsByMilestoneNameSitelevelISF
  };
};
